import React from 'react';
import SaveIcon from '@mui/icons-material/Save';
import RestoreIcon from '@mui/icons-material/Restore';
import { PlateEditor } from '@/components/editor/plate-editor';
import HtmlEditor from '../htmleditor/html-editor';
import Keywords from '../keywords/keywords';
import { SettingsProvider } from '@/components/editor/settings'; 
import { TemplateEditorLayoutProps } from '../types/types';

const TemplateEditorLayout: React.FC<TemplateEditorLayoutProps> = ({
  htmlMode,
  activeMode,
  setActiveMode,
  turnHTMLModeOn,
  turnHTMLModeOff,
  selectedWord,
  showPreview,
  setShowPreview,
  showPreviewHtml,
  editTemp,
  setTemplateDetailsData,
  getCurrentHtml,
  getCurrentHtmlForUpdate,
  wordClicked,
  placeholders,
  templateDetailsData,
}) => {
  return (
    <SettingsProvider>
      <div className="flex p-2 templatebuilderwrapper">
        <div className="w-5/6 pr-1">
          {!htmlMode && (
            <PlateEditor
              selectedWord={selectedWord}
              showPreview={showPreview}
              showPreviewHtml={showPreviewHtml}
              htmlMode={htmlMode}
              editTemp={editTemp}
              templateHtml={templateDetailsData.templateHtml}
            />
          )}
          {htmlMode && <HtmlEditor setTemplateDetailsData={setTemplateDetailsData} templateDetailsData={templateDetailsData}/>}
          <div className="pt-2 edito-bottom-buttons-wrapper border-b border-b-border p-1 bg-gray-500 backdrop-blur-sm supports-backdrop-blur:bg-background/60">
            <button
              type="button"
              className={`footerbtn ${activeMode === 'design' ? 'activebtn' : ''}`}
              onClick={() => {
                setActiveMode('design');
                turnHTMLModeOff();
              }}
            >
              <span>Design</span>
            </button>

            <button
              type="button"
              className={`footerbtn ${activeMode === 'html' ? 'activebtn' : ''}`}
              onClick={() => {
                setActiveMode('html');
                turnHTMLModeOn();
              }}
            >
              <span>HTML</span>
            </button>

            <button
              type="button"
              className={`footerbtn ${activeMode === 'preview' ? 'activebtn' : ''}`}
              onClick={() => {
                setActiveMode('preview');
                setShowPreview(true);
              }}
            >
              <span>Preview</span>
            </button>
          </div>
        </div>

        <div className="w-1/6 filedswrapper">
          <Keywords wordClicked={wordClicked} placeholders={placeholders} />
        </div>
      </div>

      <div className="flex space-x-2 pt-4 button-wrapper">
        {!editTemp && (
          <button
            type="button"
            onClick={getCurrentHtml}
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 ml-2 me-2 mb-2 mr-2"
          >
            <SaveIcon fontSize="small" />
            Save
          </button>
        )}
        {editTemp && (
          <button
            type="button"
            onClick={getCurrentHtmlForUpdate}
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 ml-2 me-2 mb-2 mr-2"
          >
            Update
          </button>
        )}
        <button
          type="button"
          className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 ml-2 me-2 mb-2 mr-2"
        >
          <RestoreIcon fontSize="small" />
          Reset
        </button>
      </div>
    </SettingsProvider>
  );
};

export default TemplateEditorLayout;
